<IFA-header></IFA-header>
<main id="primary" class="site-main customMain">
  <section class="relative">
    <div class="container px-4 pt-5 mt-120">
      <div class="content-panelMobile">
        <div class="row d-flex">
          <div class="col-12">
            <div class="sb-tag sb-offerings mb-12">MUTUAL FUNDS</div>
            <h2 class="wealth-section-title mb-6">
              Introduction To Mutual Funds
            </h2>
            <p class="wealth-section-description">
              Know the benefits and start your wealth journey.
            </p>
          </div>
        </div>

        <!-- mutual fund Accordian-->

        <div
          class="lg:w-full lg:max-w-full post-content pb-4 pt-8 lg:pt-6 sm:pt-4">
          <div class="wp-block-columns sec-ques-ans">
            <div class="wp-block-column" style="flex-basis: 30%">
              <div class="sidebar-block sticky pt-16">
                <div
                  id="lpwtoc_widget-3"
                  class="widget widget-sidebar widget_lpwtoc_widget">
                  <!--noindex-->
                  <div
                    class="lwptoc lwptoc-autoWidth lwptoc-inherit"
                    data-smooth-scroll="1"
                    data-smooth-scroll-offset="60"
                    data-lwptoc-initialized="1">
                    <div class="lwptoc_i">
                      <div class="lwptoc_header">
                        <b class="lwptoc_title bold UpperCase">
                          INTRODUCTION TO MF
                        </b>
                      </div>
                      <div
                        class="lwptoc_items1 lwptoc_items-visible"
                        style="font-size: 12pt">
                        <ol class="lwptoc_itemWrap">
                          <li class="lwptoc_item active">
                            <a href="#Tab1" data-toggle="tab" rel="nofollow">
                              <span class="lwptoc_item_label">
                                What Are Mutual Funds?
                              </span>
                            </a>
                          </li>

                          <li class="lwptoc_item">
                            <a href="#Tab2" rel="nofollow">
                              <span class="lwptoc_item_label">
                                How a mutual fund works?
                              </span>
                            </a>
                          </li>
                          <li class="lwptoc_item">
                            <a href="#Tab3" rel="nofollow">
                              <span class="lwptoc_item_label">
                                Why invest in Mutual Funds?
                              </span>
                            </a>
                          </li>
                          <li class="lwptoc_item">
                            <a href="#Tab4" rel="nofollow">
                              <span class="lwptoc_item_label">
                                A plethora of schemes to choose from
                              </span>
                            </a>
                          </li>
                          <li class="lwptoc_item">
                            <a href="#Tab5" rel="nofollow">
                              <span class="lwptoc_item_label">
                                Open-Ended and Closed-End Funds
                              </span>
                            </a>
                          </li>

                          <li class="lwptoc_item">
                            <a href="#Tab6" rel="nofollow">
                              <span class="lwptoc_item_label">
                                Actively Managed and Passively Managed funds
                              </span>
                            </a>
                          </li>
                        </ol>
                      </div>
                    </div>
                  </div>
                  <!--/noindex-->
                </div>
              </div>
            </div>

            <div class="wp-block-column mt-120" style="flex-basis: 70%">
              <div
                class="answer-contents calculator_accordian desktop-disabled-acc"
                id="ques_ans_accordian">
                <div class="what-is-hra ans-card" id="Tab1">
                  <h2 class="is-style-fancy-heading">
                    <a
                      class="acc-title"
                      data-toggle="collapse"
                      data-parent="#ques_ans_accordian"
                      href="#Tab1_ans"
                      aria-expanded="false"
                      aria-controls="what_is_fd_calci_ans">
                      What Are Mutual Funds?
                      <i class="arrow-down"></i></a>
                  </h2>
                  <div class="collapse" id="Tab1_ans">
                    <div class="main-panel">
                      <div>
                        <p>
                          A mutual fund is a collective investment vehicle that
                          collects &amp; pools money from a number of investors
                          and invests the same in equities, bonds, government
                          securities, money market instruments.
                        </p>

                        <p>
                          The money collected in mutual fund scheme is invested
                          by professional fund managers in stocks and bonds etc.
                          in line with a scheme’s investment objective. The
                          income / gains generated from this collective
                          investment scheme are distributed proportionately
                          amongst the investors, after deducting applicable
                          expenses and levies, by calculating a scheme’s “Net
                          Asset Value” or NAV. In return, mutual fund charges a
                          small fee.
                        </p>

                        <p>
                          In short, mutual fund is a collective pool of money
                          contributed by several investors and managed by a
                          professional Fund Manager.
                        </p>

                        <p>
                          Mutual Funds in India are established in the form of a
                          Trust under Indian Trust Act, 1882, in accordance with
                          SEBI (Mutual Funds) Regulations, 1996.
                        </p>

                        <p>
                          The fees and expenses charged by the mutual funds to
                          manage a scheme are regulated and are subject to the
                          limits specified by SEBI.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="what-is-hra ans-card" id="Tab2">
                  <h2 class="is-style-fancy-heading">
                    <a
                      class="acc-title"
                      data-toggle="collapse"
                      data-parent="#ques_ans_accordian"
                      href="#Tab2_ans"
                      aria-expanded="false"
                      aria-controls="what_is_fd_calci_ans">
                      How a mutual fund works?
                      <i class="arrow-down"></i></a>
                  </h2>
                  <div class="collapse" id="Tab2_ans">
                    <div class="main-panel">
                      <div>
                        <p>
                          One should avoid the temptation to review the fund's
                          performance each time the market falls or jumps up
                          significantly. For an actively-managed equity scheme,
                          one must have patience and allow reasonable time -
                          between 18 and 24 months - for the fund to generate
                          returns in the portfolio.
                        </p>

                        <p>
                          When you invest in a mutual fund, you are pooling your
                          money with many other investors. Mutual fund issues
                          “Units” against the amount invested at the prevailing
                          NAV. Returns from a mutual fund may include income
                          distributions to investors out of dividends, interest,
                          capital gains or other income earned by the mutual
                          fund. You can also have capital gains (or losses) if
                          you sell the mutual fund units for more (or less) than
                          the amount you invested.
                        </p>

                        <p>
                          Here’s a simple way to understand the concept of a
                          Mutual Fund Unit.
                          <br />
                          Let’s say that there is a box of 12 chocolates costing
                          ₹40. Four friends decide to buy the same, but they
                          have only ₹10 each and the shopkeeper only sells by
                          the box. So the friends then decide to pool in ₹10
                          each and buy the box of 12 chocolates. Now based on
                          their contribution, they each receive 3 chocolates or
                          3 units, if equated with Mutual Funds.
                          <br />
                          And how do you calculate the cost of one unit? Simply
                          divide the total amount with the&nbsp;total
                          number&nbsp;of chocolates: 40/12 = 3.33.
                          <br />
                          So if you were to multiply the number of units (3)
                          with the cost per unit (3.33), you get the initial
                          investment of ₹10.
                        </p>
                        <p>
                          This results in each friend being a unit holder in the
                          box of chocolates that is collectively owned by all of
                          them, with each person being a part owner of the box.
                        </p>
                        <p>
                          Next, let us understand what is “Net Asset Value” or
                          NAV. Just like an equity share has a traded price, a
                          mutual fund unit has Net Asset Value per Unit. The NAV
                          is the combined market value of the shares, bonds and
                          securities held by a fund on&nbsp;any
                          particular&nbsp;day (as reduced by permitted expenses
                          and charges). NAV per Unit represents the market value
                          of all the Units in a mutual fund scheme on a given
                          day, net of all expenses and liabilities plus income
                          accrued, divided by the outstanding number of Units in
                          the scheme.
                        </p>
                        <p>
                          Mutual funds are ideal for investors who either lack
                          large sums for investment, or for those who neither
                          have the inclination nor the time to research the
                          market, yet want to grow their wealth. The money
                          collected in mutual funds is invested by professional
                          fund managers in line with the scheme’s stated
                          objective. In return, the fund house charges a small
                          fee which is deducted from the investment. The fees
                          charged by mutual funds are regulated and are subject
                          to certain limits specified by the Securities and
                          Exchange Board of India (SEBI).
                        </p>
                        <p>
                          India has one of the highest savings rate globally.
                          This penchant for wealth creation makes it necessary
                          for Indian investors to look beyond the traditionally
                          favoured bank FDs and gold towards mutual funds.
                          However, lack of awareness has made mutual funds a
                          less preferred investment avenue.
                        </p>
                        <p>
                          Mutual funds offer multiple product choices for
                          investment across the financial spectrum. As
                          investment goals vary – post-retirement expenses,
                          money for children’s education or marriage, house
                          purchase, etc. – the products required to achieve
                          these goals vary too. The Indian mutual fund industry
                          offers a plethora of schemes and caters to all types
                          of investor needs.
                        </p>
                        <p>
                          Mutual funds offer an excellent avenue for retail
                          investors to participate and benefit from the uptrends
                          in capital markets. While investing in mutual funds
                          can be beneficial, selecting the right fund can be
                          challenging. Hence, investors should do proper due
                          diligence of the fund and take into consideration the
                          risk-return trade-off and time horizon or consult a
                          professional investment adviser. Further, in order to
                          reap maximum benefit from mutual fund investments, it
                          is important for investors to diversify across
                          different categories of funds such as equity, debt and
                          gold.
                        </p>
                        <p>
                          While investors of all categories can invest in
                          securities market on their own, a mutual fund is a
                          better choice for the only reason that all benefits
                          come in a package.
                        </p>

                        <h3>Mutual funds are ideal for investors who –</h3>

                        <ol type="a">
                          <li>
                            lack the knowledge or skill / experience of
                            investing in stock markets directly.
                          </li>
                          <li>
                            want to grow their wealth, but do not have the
                            inclination or time to research the stock market.
                          </li>
                          <li>wish to invest only small amounts.</li>
                        </ol>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="what-is-hra ans-card" id="Tab3">
                  <h2 class="is-style-fancy-heading">
                    <a
                      class="acc-title"
                      data-toggle="collapse"
                      data-parent="#ques_ans_accordian"
                      href="#Tab3_ans"
                      aria-expanded="false"
                      aria-controls="what_is_fd_calci_ans">
                      Why invest in Mutual Funds?
                      <i class="arrow-down"></i></a>
                  </h2>
                  <div class="collapse" id="Tab3_ans">
                    <div class="main-panel">
                      <div>
                        <p>
                          As investment goals vary from person to person –
                          post-retirement expenses, money for children’s
                          education or marriage, house purchase, etc. – the
                          investment products required to achieve these goals
                          too vary. Mutual funds provide certain distinct
                          advantages over investing in individual securities.
                          Mutual funds offer multiple choices for investment
                          across equity shares, corporate bonds, government
                          securities, and money market instruments, providing an
                          excellent avenue for retail investors to participate
                          and benefit from the uptrends in capital markets. The
                          main advantages are that you can invest in a variety
                          of securities for a relatively low cost and leave the
                          investment decisions to a professional manager.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="what-is-hra ans-card" id="Tab4">
                  <h2 class="is-style-fancy-heading">
                    <a
                      class="acc-title"
                      data-toggle="collapse"
                      data-parent="#ques_ans_accordian"
                      href="#Tab4_ans"
                      aria-expanded="false"
                      aria-controls="what_is_fd_calci_ans">
                      A plethora of schemes to choose from
                      <i class="arrow-down"></i></a>
                  </h2>
                  <div class="collapse" id="Tab4_ans">
                    <div class="main-panel">
                      <div>
                        <p>
                          Mutual funds are favoured globally for the variety of
                          investment options they offer. There is something for
                          every profile and preference.
                        </p>
                        <p class="red-txt">
                          Chart 1: Risk/Return trade-off by mutual fund category
                        </p>
                        <p class="center">
                          <img
                            src="assets/images/img/risk-return.jpg"
                            alt="Risk/Return trade-off by mutual fund category" />
                        </p>

                        <!-- <h4 class="sub-head-new sub-heading main-block animated fadeInDown">Type of Mutual Fund schemes</h4> -->
                        <h2
                          class="sub-head-new sub-heading main-block animated fadeInDown">
                          Type of Mutual Fund schemes
                        </h2>
                        <!-- <div class="padl15"> -->
                        <p>
                          Mutual Fund schemes could be ‘open ended’ or
                          close-ended’ and actively managed or passively
                          managed.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="what-is-hra ans-card" id="Tab5">
                  <h2 class="is-style-fancy-heading">
                    <a
                      class="acc-title"
                      data-toggle="collapse"
                      data-parent="#ques_ans_accordian"
                      href="#Tab5_ans"
                      aria-expanded="false"
                      aria-controls="what_is_fd_calci_ans">
                      Open-Ended and Closed-End Funds
                      <i class="arrow-down"></i></a>
                  </h2>
                  <div class="collapse" id="Tab5_ans">
                    <div class="main-panel">
                      <div>
                        <p>
                          An open-end fund is a mutual fund scheme that is
                          available for subscription and redemption on every
                          business throughout the year, (akin to a savings bank
                          account, wherein one may deposit and withdraw money
                          every day). An open ended scheme is perpetual and does
                          not have any maturity date.
                        </p>

                        <p>
                          A closed-end fund is open for subscription only during
                          the initial offer period and has a specified tenor and
                          fixed maturity date (akin to a fixed term deposit).
                          Units of Closed-end funds can be redeemed only on
                          maturity (i.e., pre-mature redemption is not
                          permitted). Hence, the Units of a closed-end fund are
                          compulsorily listed on a stock exchange after the new
                          fund offer, and are traded on the stock exchange just
                          like other stocks, so that investors seeking to exit
                          the scheme before maturity may sell their Units on the
                          exchange.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="what-is-hra ans-card" id="Tab6">
                  <h2 class="is-style-fancy-heading">
                    <a
                      class="acc-title"
                      data-toggle="collapse"
                      data-parent="#ques_ans_accordian"
                      href="#Tab6_ans"
                      aria-expanded="false"
                      aria-controls="what_is_fd_calci_ans">
                      Actively Managed and Passively Managed funds
                      <i class="arrow-down"></i></a>
                  </h2>
                  <div class="collapse" id="Tab6_ans">
                    <div class="main-panel">
                      <div>
                        <p>
                          An actively managed fund is a mutual fund scheme in
                          which the fund manager “actively” manages the
                          portfolio and continuously monitors the fund's
                          portfolio , deciding on which stocks to buy/sell/hold
                          and when, using his professional judgement, backed by
                          analytical research. In an active fund, the fund
                          manager’s aim is to generate maximum returns and
                          out-perform the scheme’s bench mark.
                        </p>
                        <p>
                          A passively managed fund, by contrast, simply follows
                          a market index, i.e., in a passive fund , the fund
                          manager remains inactive or passive inasmuch as, she
                          does not use her judgement or discretion to decide as
                          to which stocks to buy/sell/hold , but simply
                          replicates / tracks the scheme’s benchmark index in
                          exactly the same proportion. Examples of Index funds
                          are an Index Fund and all Exchange Traded Funds. In a
                          passive fund, the fund manager’s task is to simply
                          replicate the scheme’s benchmark index i.e., generate
                          the same returns as the index, and not to out-perform
                          the scheme’s bench mark.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- End-->
      </div>
    </div>
  </section>
  <section class="grid-layout-common">
    <div class="container">
      <div class="col-md-12 col-xs-12 col-sm-12 nopadding">
        <div class="product-card-grid hover-animation" data-grid-size="8">
          <a
            id="id-45ec3075-02fd-412a-b8a5-9aeea39facf3"
            class="card active"
            href="mf/Mutual-Fund"
            target="_self">
            <span>
              Mutual Funds -
              <br />
              <span class="no-wrap-text">Introduction & More</span>
            </span>
            <span class="icon fa fa-angle-right"></span>
          </a>
          <a
            id="id-45ec3075-02fd-412a-b8a5-9aeea39facf3"
            class="card"
            href="mf/Types_Of_MF"
            target="_self">
            <span>
              Various types
              <br />
              <span class="no-wrap-text">of Mutual Funds</span>
            </span>
            <span class="icon fa fa-angle-right"></span>
          </a>
          <a
            id="id-45ec3075-02fd-412a-b8a5-9aeea39facf3"
            class="card"
            href="mf/SIP"
            target="_self">
            <span>
              Systematic
              <br />
              <span class="no-wrap-text">Investment Plan?</span>
            </span>
            <span class="icon fa fa-angle-right"></span>
          </a>
          <a
            id="id-45ec3075-02fd-412a-b8a5-9aeea39facf3"
            class="card"
            href="mf/Advantages_Of_MutualFundsComponent"
            target="_self">
            <span>
              Advantages of
              <br />
              <span class="no-wrap-text">Mutual Funds</span>
            </span>
            <span class="icon fa fa-angle-right"></span>
          </a>
          <a
            id="id-45ec3075-02fd-412a-b8a5-9aeea39facf3"
            class="card"
            href="mf/categorization-of-mutual-funds"
            target="_self">
            <span>
              Categorisation of
              <br />
              <span class="no-wrap-text">Mutual Funds</span>
            </span>
            <span class="icon fa fa-angle-right"></span>
          </a>
          <a
            id="id-45ec3075-02fd-412a-b8a5-9aeea39facf3"
            class="card"
            href="mf/risks-in-mutual-funds"
            target="_self">
            <span>
              Risk Factors in
              <br />
              <span class="no-wrap-text">Mutual Funds</span>
            </span>
            <span class="icon fa fa-angle-right"></span>
          </a>
          <a
            id="id-45ec3075-02fd-412a-b8a5-9aeea39facf3"
            class="card"
            href="mf/FAQ#Myth"
            target="_self">
            <span>
              Myths & Facts
              <br />
              <span class="no-wrap-text">about Mutual Funds</span>
            </span>
            <span class="icon fa fa-angle-right"></span>
          </a>
          <a
            id="id-45ec3075-02fd-412a-b8a5-9aeea39facf3"
            class="card"
            href="mf/FAQ#FAQ"
            target="_self">
            <span>
              What is NAV?
              <br />
              <span class="no-wrap-text">& Other FAQs</span>
            </span>
            <span class="icon fa fa-angle-right"></span>
          </a>
          <a
            id="id-ebe318f3-49dd-4b4f-9c3a-0cb8514a69fd"
            class="card link-plain featured customCard"
            (click)="modalPopOpen()"
            target="_self">
            <p
              style="
                font-size: 19px;
                color: #000;
                font-weight: bold;
                margin-bottom: 0px;
              ">
              Schedule a Call back
            </p>
          </a>
        </div>
      </div>
    </div>
  </section>
  <!-- lets talk of model -->

  <div
    aria-hidden="true"
    aria-labelledby="LetsTalk_popup"
    class="modal fade"
    data-keyboard="false"
    id="LetsTalk_popup"
    tabindex="-1">
    <div class="modal-dialog modal-dialog-centered border-0">
      <div class="modal-content border-0 p-0">
        <div class="modal-header border-0 p-0 ltmodalheader">
          <button
            aria-label="Close"
            class="close"
            data-dismiss="modal"
            type="button">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body border-0 p-10 pt-0 mobilep-2">
          <form>
            <div
              class="col-sm-12 col-md-12 col-xs-12 schedule-a-call-container">
              <div class="align-self-center">
                <h2
                  class="wealth-section-title mb-8 mobilemb-5 mobilemt-0 fcwelth">
                  Let's Talk
                </h2>

                <p
                  class="wealth-section-description mb-12 mt-10 mobilemt-0 mobilemb-10">
                  Let's connect on a quick call to understand better.
                </p>
              </div>

              <div class="row">
                <div class="col-sm-12 col-md-12 col-xs-12 mt-10 mobilemt-0">
                  <div class="call-plan-form-group call-plan-form-group-name">
                    <input
                      class="form-control"
                      id="customer_name"
                      maxlength="30"
                      placeholder="Full Name"
                      name="customer-name"
                      required=""
                      type="text" />
                    <label for="customer-name"></label>
                    <span class="d-none customer-name-error" style="color: red">
                      Please enter your name
                    </span>
                  </div>
                </div>
                <!-- <div class="col-sm-6 col-md-6 col-xs-6 MobileHide">
                    <div class="call-plan-form-group call-plan-form-group-name">

                      <input class="form-control" id="customer_name" placeholder="last name"
                        maxlength="30" name="customer-name" required="" type="text">
                      <label for="customer-name"></label>
                      <span class="d-none customer-name-error" style="color: red">
                        Please enter your name
                      </span>
                    </div>
                  </div> -->
              </div>
              <div class="row">
                <div class="col-sm-6 col-md-6 col-xs-6">
                  <div class="call-plan-form-group call-plan-form-group-name">
                    <input
                      class="form-control"
                      id="customer_name"
                      maxlength="30"
                      placeholder="Mobile"
                      name="customer-name"
                      required=""
                      type="text" />
                    <label for="customer-name"></label>
                    <span class="d-none customer-name-error" style="color: red">
                      Please enter your name
                    </span>
                  </div>
                </div>
                <div class="col-sm-6 col-md-6 col-xs-6">
                  <div class="call-plan-form-group call-plan-form-group-name">
                    <input
                      class="form-control"
                      id="customer_name"
                      placeholder="Email"
                      maxlength="30"
                      name="customer-name"
                      required=""
                      type="text" />
                    <label for="customer-name"></label>
                    <span class="d-none customer-name-error" style="color: red">
                      Please enter your name
                    </span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6 col-md-6 col-xs-6">
                  <div class="call-plan-form-group call-plan-form-group-name">
                    <!-- <select class="form-control">
                      <option>State</option>
                    </select> -->
                    <input
                      class="form-control"
                      id="Statein"
                      placeholder="State"
                      maxlength="30"
                      name="Statein"
                      required=""
                      type="text" />
                    <label for="Statein"></label>
                    <span class="d-none Statein-error" style="color: red">
                      Please enter state
                    </span>
                  </div>
                </div>
                <div class="col-sm-6 col-md-6 col-xs-6">
                  <div class="call-plan-form-group call-plan-form-group-name">
                    <input
                      class="form-control"
                      id="customer_name"
                      maxlength="30"
                      placeholder="City"
                      name="customer-name"
                      required=""
                      type="text" />
                    <label for="customer-name"></label>
                    <span class="d-none customer-name-error" style="color: red">
                      Please enter your name
                    </span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-12 col-xs-6">
                  <div class="call-plan-form-group call-plan-form-group-name">
                    <input
                      class="form-control"
                      id="customer_name"
                      maxlength="30"
                      placeholder="Message"
                      name="customer-name"
                      required=""
                      type="text" />
                    <label for="customer-name"></label>
                    <span class="d-none customer-name-error" style="color: red">
                      Please enter your name
                    </span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 col-sm-12 col-xs-12">
                  <div class="call-plan-form-group">
                    <label class="form-label">Preferred time to talk:</label>
                  </div>
                  <div
                    class="btn-group btn-group-toggle select-call-time select-call-time-js"
                    data-toggle="buttons">
                    <label class="btn btn-outline-sb-green option-1 active">
                      <input
                        data-max="12"
                        data-min="8"
                        id="option1"
                        name="schedule_time"
                        type="radio"
                        value="morning" />

                      10 - 12
                    </label>
                    <label class="btn btn-outline-sb-green option-2">
                      <input
                        data-max="16"
                        data-min="12"
                        id="option2"
                        name="schedule_time"
                        type="radio"
                        value="afternoon" />

                      12 - 2
                    </label>
                    <label class="btn btn-outline-sb-green option-3">
                      <input
                        data-max="20"
                        data-min="16"
                        id="option3"
                        name="schedule_time"
                        type="radio"
                        value="evening" />

                      2 - 4
                    </label>
                    <label class="btn btn-outline-sb-green option-3">
                      <input
                        data-max="20"
                        data-min="16"
                        id="option3"
                        name="schedule_time"
                        type="radio"
                        value="evening" />

                      4 - 6
                    </label>
                    <label class="btn btn-outline-sb-green option-3">
                      <input
                        data-max="20"
                        data-min="16"
                        id="option3"
                        name="schedule_time"
                        type="radio"
                        value="evening" />

                      6 - 8
                    </label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 mb-20">
                  <div
                    class="call-plan-form-group text-center mt-30 mobilemt-0 mobilemb-0">
                    <div
                      class="mt-3 sb-primary-cta-button large-btn schedule-a-call trigger-event schedule-a-call-js"
                      data-action="schedule a call-Plan"
                      data-category="offering-Plan"
                      data-label="planning section">
                      Call Me
                    </div>
                    <a
                      href="mf/MobileMutualFund"
                      style="font-size: 10px"
                      target="_self"
                      class="anchorColor desktopHide">
                      Click here to know more about Mutual Funds first
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <!-- end-->
</main>

<IFA-footer></IFA-footer>
